import type {ReactAction} from '@netx/core/bootstrap';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canRemoveAssetFromCart} from '../enablers';
import {CartAssetActionLabel} from '../locales';
import {CART_ASSET_EVENT} from './constants';

/**
 * Remove asset to current cart
 * @param params
 * @returns Action
 */
export const cartAssetActionRemove = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-asset-remove',
	cb: () =>
		dispatcher.trigger(CART_ASSET_EVENT.REMOVE_FROM_CART, asset.assetId),
	enableTest: canRemoveAssetFromCart,
	icon: faTimes,
	get label() {
		return CartAssetActionLabel.REMOVE_FROM_CART;
	},
	...params,
});
